export default {
  promos: []
}
